var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccelerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59555 11.8169C4.59555 7.8246 7.83192 4.58822 11.8242 4.58822M16.4711 7.16988L11.8241 11.8169M22.1508 11.8169C22.1508 17.5201 17.5274 22.1435 11.8242 22.1435C6.12095 22.1435 1.49756 17.5201 1.49756 11.8169C1.49756 6.11363 6.12095 1.49023 11.8242 1.49023C17.5274 1.49023 22.1508 6.11363 22.1508 11.8169ZM12.8569 11.8169C12.8569 12.3872 12.3945 12.8495 11.8242 12.8495C11.2539 12.8495 10.7915 12.3872 10.7915 11.8169C10.7915 11.2465 11.2539 10.7842 11.8242 10.7842C12.3945 10.7842 12.8569 11.2465 12.8569 11.8169Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccelerator);
export default __webpack_public_path__ + "static/media/accelerator.c130491871f7e1095568adf4cfb7cc1a.svg";
export { ForwardRef as ReactComponent };